import React from "react";

function useScrollToTop(){
    window.scrollTo(0,0)
}

export default useScrollToTop;